interface IShouldShowAuthIllustrationProps {
  // NOTE: NSAI-6144 — the white-label half of the rule: a flavored build shows
  // no artwork on any auth surface, so both `AuthLayout` (sign in / sign up /
  // SSO) and `CenterCardLayout` (password recovery and reset, accept invite, the
  // shared page and the public share / public chat state screens) pass
  // `isOplotFlavor()` straight through. It stays an INPUT rather than a call
  // inside this helper on purpose: `VITE_PLATFORM_FLAVOR` is baked into the
  // bundle at build time and CI builds the default flavor, so a helper that read
  // the flavor itself would put the white-label row of this truth table beyond
  // anything CI can execute.
  isFlavorGated: boolean;
  // NOTE: `hasCustomBranding` is false while the public branding lookup is still
  // in flight, so the unresolved state is not a confirmed default appearance:
  // painting on it would flash NodeShift artwork at a branded visitor.
  isBrandingResolved: boolean;
  // NOTE: An organization that configured its own appearance gets the form
  // full-width, so the NodeShift artwork never sits next to someone else's
  // branding. `VITE_ON_PREMISE` is deliberately not an input here — the cloud
  // channels ship the on-premise-built UI image by design, so the flag is true
  // on ai.nodeshift.com itself and cannot tell NodeShift's cloud from a
  // customer install (NSAI-5315).
  hasCustomBranding: boolean;
}

export const shouldShowAuthIllustration = ({
  isFlavorGated,
  isBrandingResolved,
  hasCustomBranding,
}: IShouldShowAuthIllustrationProps): boolean => {
  return !isFlavorGated && isBrandingResolved && !hasCustomBranding;
};
